export const isRtlPlusType = (type: string): boolean => type === 'rtl-plus-episodes' || type === 'rtl-plus-series';
